import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  const [activeTab, setActiveTab] = useState('all');

  const filtered = useMemo(() => {
    if (activeTab === 'all') return comics.slice(0, 8);
    return comics.filter((c) => c.category === activeTab).slice(0, 8);
  }, [activeTab]);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">精选高分漫画，大家都在看</p>
          </div>
          <Link
            to="/category/kr"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-8">
          <div className="flex items-center bg-background-200/70 rounded-full px-1 py-1">
            {[{ slug: 'all', label: '全部' }, ...categories].map((tab) => (
              <button
                key={tab.slug}
                onClick={() => setActiveTab(tab.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab.slug
                    ? 'bg-primary-500 text-white shadow-sm'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}